<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="编码或名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="getUsers">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="info" @click="addUser">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table :data="infoList" style="width: 100%">
     <!-- <el-table-column prop="id" label="id" width="180"></el-table-column>-->
      <el-table-column prop="typeCode" label="商品编码" width="180">
      </el-table-column>
      <el-table-column prop="typeName" label="商品名称" width="180">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180">
      </el-table-column>
      <el-table-column prop="modifyTime" label="更新时间" width="180">
      </el-table-column>
      <!--第二步  开始进行修改和查询操作-->
      <el-table-column label="操作" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button type="primary" @click="checkDetail(scope.row)">详情</el-button>
          <el-button type="warning" @click="modifyUser(scope.row)">修改</el-button>
          <el-button type="danger" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" style="text-align: right; padding-right: 19px; padding-top: 7px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
    <!--新增界面-->
    <el-dialog title="记录" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addFormData" :rules="rules2" ref="addFormData" label-width="150px" class="demo-ruleForm login-container">
        <el-row>
          <el-col>
            <el-form-item prop="typeCode" label="产品编码">
              <el-input type="text" v-model="addFormData.typeCode" auto-complete="off" placeholder="产品编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="typeName" label="产品名称">
              <el-input type="text" v-model="addFormData.typeName" auto-complete="off" placeholder="产品名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click.native="dialogVisible = false,addFormData={id:'',typeCode:'',typeName:''}">取 消</el-button>
          <el-button v-if="isView" type="primary" @click.native="addSubmit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
    api
} from '../../api/login';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'home',
    data() {
        return {
            infoList: [],
            addFormReadOnly: true,
            dialogVisible: false,
            isView: true,
            addFormData: {
                id: '',
                typeCode: '',
                typeName: ''
            },
            rules2: {
              typeCode: [{
                    required: true,
                    message: '产品类型不能为空',
                    trigger: 'blur'
                }],
              typeName: [{
                    required: true,
                    message: '产品名称不能为空',
                    trigger: 'blur'
                }]
            },
            filters: {
                name: ''
            },

            cur_page:1,//默认在第一页
            pageNum:10,//默认每页显示1条数据
            totalCount:1 //默认总条数为一条
        }
    },
    mounted: function () {
        this.loadData();
    },
    methods: {
        handleSizeChange(val) {
          this.pageNum=val;//获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
          this.loadData();//展示页面信息
        },
        handleCurrentChange(val) {
          this.cur_page = val;
          this.loadData();//确定当前页面后刷新页面
        },
        loadData() {
            let param = {current:this.cur_page,size:this.pageNum,filter:this.filters.name};
            axios.post('/yogaProductType/list', param).then((result) => {
                //console.info(result);
                if(result.data.code == 0){
                    var _data = result.data.data.records;
                    this.infoList = _data;
                    this.cur_page=result.data.data.current;//默认在第一页
                    this.pageNum=result.data.data.size;//默认每页显示1条数据
                    this.totalCount=result.data.data.total;//默认总条数为一条
                }else{
                  this.$message({
                    type: 'error',
                    message: `查询数据失败`
                  });
                }
            });
        },
        getUsers() {
            this.loadData();
        },
        addUser() {
            this.addFormData = {
                id: '',
              typeCode: '',
              typeName: ''
            };
            this.isView = true;
            this.dialogVisible = true;
            //    this.addFormReadOnly = false;
        },
        checkDetail(rowData) {
            this.addFormData = Object.assign({}, rowData);
            this.isView = false;
            this.dialogVisible = true;
        },
        modifyUser(rowData) {
            //this.addFormData = Object.assign({}, rowData);
            this.addFormData = {
              id: rowData.id,
              typeCode: rowData.typeCode,
              typeName: rowData.typeName
            }
            this.isView = true;
            this.dialogVisible = true;
            //    this.addFormReadOnly = false;
        },
        deleteUser(rowData) {
            this.$confirm('是否删除这条记录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              var params = {
                id: rowData.id
              };
              axios.post("/yogaProductType/delete?id="+rowData.id).then((result) => {
                //console.info(result);
                if(result.data.code == 0){
                    this.$message({
                      type: 'success',
                      message: '删除成功'
                    });
                  this.loadData();
                }else{
                  this.$message({
                    type: 'error',
                    message: result.data.message
                  });
                }
              });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
        },
        //增加一条记录
        addSubmit() {
            //先判断表单是否通过了判断
            this.$refs.addFormData.validate((valid) => {
                //代表通过验证 ,将参数传回后台
                if (valid) {
                    let param = Object.assign({}, this.addFormData);
                    axios.post("/yogaProductType/submit", param).then((result) => {
                        //alert(result);
                        if (result.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '保存成功',
                            });
                            this.loadData();
                        } else {
                            this.$message({
                                type: 'error',
                                message: '保存失败',
                            });
                        }
                        this.dialogVisible = false;
                    });
                }
            });
        }

    }

}
</script>



// WEBPACK FOOTER //
// src/components/yoga/YogaProductType.vue